module.exports = __webpack_public_path__ + "7a121a6e7ef417a94441cf2506b6efd6.png";